export default __webpack_public_path__ + "static/media/sw_4.43d27cc2.png";